import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Replace these values with your Firebase project config
// from https://console.firebase.google.com
const firebaseConfig = {
  apiKey: "AIzaSyDPJi40-qs-tHsSAOFQUNc7PpnAme-DjCA",
  authDomain: "le-douit-horticulture.firebaseapp.com",
  projectId: "le-douit-horticulture",
  storageBucket: "le-douit-horticulture.firebasestorage.app",
  messagingSenderId: "952687327846",
  appId: "1:952687327846:web:ba43803f288d67fb104ba7"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
